module.exports = __webpack_public_path__ + "static/img/Group2.68cd0f01.png";